const WithContactUsAttributes = (additionalAttributes = {}) => {
  return {
    'data-bs-toggle': 'modal',
    'data-bs-target': '#contactUsModal',
    'data-bs-type': 'contact-us',
    'data-bs-title': 'Contact Us',
    ...additionalAttributes,
  };
};

const WithRequestDemo = (additionalAttributes = {}) => {
  return {
    'data-bs-toggle': 'modal',
    'data-bs-target': '#contactUsModal',
    'data-bs-type': 'trial-contact',
    'data-bs-title': 'Contact Us',
    ...additionalAttributes,
  };
};

export default WithContactUsAttributes;
export { WithRequestDemo };